import { RunContextApp }                              from "framework/RCApp";
import { ApiResponse }                                from "types";
import { CONFIG_API_CONSTANTS,  
  GetConfigsAPI }                                     from "types/common/configs/baseConfigs";
import { AxiosRequestConfig }                         from "axios"

export const sessionApis = {
  fetchConfigsStrings : async (rc: RunContextApp, params: GetConfigsAPI.params)
    : Promise<ApiResponse<GetConfigsAPI.retval>> => {

    const request: AxiosRequestConfig = {
      params: sessionApis.prepareParams(params)
    }
    const resp = await rc.apiClient.post<GetConfigsAPI.retval>(GetConfigsAPI.apiEndpoint(),[], request)
    if(resp.error){
      //Logout user if token is invalid.
      rc.session.logoutUser();
    }
    return resp
  },

  prepareParams: (options: GetConfigsAPI.params) => {
    return {
      pilotId: options.pilotId,
      scoped: options.scoped || false,
      context: options.context || CONFIG_API_CONSTANTS.CONTEXT,
      colorPaletteThemeType: options.colorPaletteThemeType || CONFIG_API_CONSTANTS.COLOR_PALETTE,
      colorPaletteType: options.colorPaletteType ,
      configTagType: options.configTagType || CONFIG_API_CONSTANTS.CONFIG_TAG_TYPE,
      stringTagType: options.stringTagType || CONFIG_API_CONSTANTS.STRING_TAG_TYPE,
    }
  }
}